export default __webpack_public_path__ + "static/media/logo-palm-siever.a77cd8d0.png";